import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from '../../globals';
import { AssessmentsService } from '../../services/assessment/AssessmentsService';
import { GridOptions } from 'ag-grid';
import { CoachService } from '../../services/coach/CoachService';
import { ToastrService } from 'ngx-toastr';
import { AdminService, AdminAssessmentPurchaseDto } from '../../services/admin/AdminService';
import { CryptoJs } from '../../shared/crypto-js/crypto-js.component';
declare var jquery: any;
declare var $: any;
import { NgProgress, NgProgressRef } from 'ngx-progressbar';

@Component({
  selector: 'app-assessments-mod-i',
  templateUrl: './assessments-mod-i.component.html',
  styleUrls: ['./assessments-mod-i.component.scss']
})
export class AssessmentsModIComponent implements OnInit {

    mod3Dates: string[] = [];
    totalStudents: number = 0;
    pending: number = 0;
    completed: number = 0;
    pendings: any[] = [];
    completedData: any[] = [];
    pendingsHeaders: any[];
    completedHeaders: any[];
    gridOptions: GridOptions;
    pendingGridApi;
    completedGridApi;
    gridColumnApi;
    overlayNoRowsTemplate;
    rowCount: number;
    rowCountData: any;
    canRemind: boolean = false;
    showReminderBtn: boolean = false;
    loading = true;
    reminding: boolean = false;
    currentSelectedTab: number = 1;
    canDownload: boolean = false;
    canEnableResults: boolean = false;
    enabling: boolean = false;
    downloading: boolean = false;
    /*UNASSIGN*/
    canUnassign: boolean = false;
    unassigning: boolean = false;
    addingStudent: boolean = false;
    todayDate: Date = this.getTodayDate2();
    todaysDate: Date = new Date();
    settings = {
        bigBanner: false,
        timePicker: false,
        format: 'MM-dd-yyyy',
        defaultOpen: false
    };

    displayContent: boolean = true;
    getStudentsFlag: boolean = false;
    creatingGroupFlag: boolean = false;
    backgroundProcessInProgressFlag: boolean = false;
    partialGroupFlag = false;
    checkNewGroupProcessActive: boolean = false;
    canDefer: boolean = false;
    deferring: boolean = false;
    canAssign: boolean = false;
    quantity: number = 1;
    assigningAssessmentsFlag: boolean = false;
    showActionButtonsForGroup: boolean = true;
    synchronizing: boolean = false;
    progressRef: NgProgressRef;

    constructor(
        private _Router: Router,
        private _Globals: Globals,
        private _AssessmentsService: AssessmentsService,
        private _CoachService: CoachService,
        private _toastr: ToastrService,
        private _AdminService: AdminService,
        private _CryptoJs: CryptoJs,
        public ngProgress: NgProgress
    ) {
        if (!this._Globals.userHasSpecificMode('Administrator')) {
            this._Router.navigate(["/app/coach_home"]);
        }

        this.overlayNoRowsTemplate = "<span>No row to show</span>";
    }

    ngOnInit() {
        this.progressRef = this.ngProgress.ref();
        this.gridOptions = <GridOptions>{};
        this.gridOptions.rowHeight = 45;
        this.gridOptions.headerHeight = 40;
        this.pendingsHeaders = this.createPendingHeaders();
        this.completedHeaders = this.createCompletedHeaders();

        this.getAssessmentsValues(this.getTodayDate2());
    }

    ngOnDestroy() {
        console.log('destroy component');
        this.checkNewGroupProcessActive = false;
    }

    private getTodayDate2() {
        var today: any = new Date();
        var dd: any = today.getDate();

        var mm: any = today.getMonth() + 1;
        var yyyy = today.getFullYear();
        if (dd < 10) {
            dd = '0' + dd;
        }

        if (mm < 10) {
            mm = '0' + mm;
        }
        today = yyyy + '-' + mm + '-' + dd;
        /*        console.log(today);*/

        return today;
    }

    // private getTodayDate() {
    //     var today: any = new Date();
    //     var dd: any = today.getDate();

    //     var mm: any = today.getMonth() + 1;
    //     var yyyy = today.getFullYear();
    //     if (dd < 10) {
    //         dd = '0' + dd;
    //     }

    //     if (mm < 10) {
    //         mm = '0' + mm;
    //     }
    //     today = yyyy + '-' + mm + '-' + dd + 'T00:00:00';
    //     console.log(today);

    //     return today;
    // }

    getAssessmentsValues(date: string) {

        console.log('DATE', date);
        $('body').css('cursor', 'wait');
        //2020-04-21T00:00:00 
        //04-21-2020T00:00:00 //        

        setTimeout(() => {

            // if (date == undefined) date = this.getDateTimePikerValue(false);

            if (date == undefined) date = this.getInputDateValue(false);

            //let dateValue = this.getDateTimePikerValue(false);

            console.log('TEXT', date);
            // console.log('VALUE', dateValue);

            this.checkNewGroupProcessActive = false;
            this.backgroundProcessInProgressFlag = false;
            this.creatingGroupFlag = false;

            this.getAssessmentMod1Stats(date);

            this.canDownload = false;
            this.canEnableResults = false;

        }, 10);


    }

    getAssessmentMod1Stats(date: string) {
        if (date.indexOf("T") === -1) {
            date = date.concat('T00:00:00');
        }
        this.loading = true;

        this._AssessmentsService.getAssessmentMod1Stats(date).subscribe((data: any) => {
            console.log('data', data);
            if (this._Globals.validationToken(data.result.Result)) {

                this.loading = false;
                switch (data.result.Result) {
                    case 0:
                        this._toastr.error("We are sorry. An unexpected error happened while trying to get the MOD 1 info for the selected date.", "ELI");
                        break;
                    case 1:
                        let _data = JSON.parse(data.result.Data);
                        console.log('response_getAssessmentModStats', _data);

                        let stats = (_data.Stats != null) ? _data.Stats : [];
                        let groupStatus = _data.Status;

                        this.setActiveTab();

                        //1. A group was found for the selected date
                        if (stats.length != 0) {

                            this.getAssessementMod1Pendings(this.getInputDateValue(false), false);
                            this.getAssessementMod1Completed(this.getInputDateValue(false), false);

                            if (groupStatus == 0 || groupStatus == 3) {
                                this.showActionButtonsForGroup = true;
                            } else {
                                this.showActionButtonsForGroup = false;
                            }

                            this.displayContent = true;
                            this.totalStudents = 0;
                            this.pending = 0;
                            this.completed = 0;

                            stats.forEach((item) => {
                                console.log(item);
                                switch (item.Status) {
                                    case 1://not started
                                        this.totalStudents = this.totalStudents + item.Amount;
                                        this.pending = this.pending + item.Amount;
                                        break;
                                    case 2://in progress
                                        this.totalStudents = this.totalStudents + item.Amount;
                                        this.pending = this.pending + item.Amount;
                                        break;
                                    case 3://completed
                                        this.totalStudents = this.totalStudents + item.Amount;
                                        this.completed = this.completed + item.Amount;
                                        break;
                                }
                            });

                            console.log('totalStudents', this.totalStudents);
                            console.log('pending', this.pending);
                            console.log('completed', this.completed);
                        } else {
                            //switch (_data.Status) {

                            //    //No group found for the selected date
                            //    case 0:
                            //        this.displayContent = false;
                            //        this.showActionButtonsForGroup = true;
                            //        break;

                            //    //A group is being created in background for this date
                            //    case 2:
                            //        this.backgroundProcessInProgressFlag = true;
                            //        this.creatingGroupFlag = true;
                            //        this.checkNewGroupProcessActive = true;
                            //        this.displayContent = false;
                            //        this.showActionButtonsForGroup = false;
                            //        if (this.checkNewGroupProcessActive) setTimeout(() => { this.getAssessmentModStats(this.getDateTimePikerValue(false)); }, 20000);
                            //        break

                            //    //A partial group was found for the selected date
                            //    case 3:
                            //        this.partialGroupFlag = true;
                            //        this.displayContent = false;
                            //        this.showActionButtonsForGroup = true;
                            //        break;

                            //}


                            this.displayContent = true;
                            this.totalStudents = 0;
                            this.pending = 0;
                            this.completed = 0;

                            this.pendings = [];
                            this.completedData = [];


                        }
                        break;
                }

                this.synchronizing = false;
                this.loading = false;
                $('body').css('cursor', 'default');
                setTimeout(() => {
                    $('.assessmentsModlll .wc-date-container').css('border', '1px solid #ccc');
                    $('.assessmentsModlll .wc-date-container > i').css('color', '#46a8ce');
                }, 100);

            }
            this.loading = false;
        },
            (error) => {
                this.loading = false;
            });
    }

    getAssessementMod1Pendings(date: string, sizeToFit: boolean, hideDeferModal: boolean = false) {
        this._AssessmentsService.getAssessementMod1Pendings(date).subscribe((data: any) => {
            console.log('response_getAssessementMod1Pendings', data);
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('_data', _data);

                this.pendings = _data;
                if (sizeToFit) this.sizeToFit(this.pendingGridApi);
                if (hideDeferModal) {
                    this.hideDeferModal();
                    this.deferring = false;
                }
                this.synchronizing = false;
                this.loading = false;
            }
        });
    }

    getAssessementMod1Completed(date: string, sizeToFit: boolean, hideDeferModal: boolean = false) {
        this._AssessmentsService.getAssessementMod1Completed(date).subscribe((data: any) => {
            console.log('response_getAssessementMod1Completed', data);
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('_data', _data);

                this.completedData = _data;

                if (this.completedData.length > 0) {
                    this.canDownload = true;
                    this.canEnableResults = true;
                }

                if (sizeToFit) this.sizeToFit(this.completedGridApi);
                if (hideDeferModal) {
                    this.hideDeferModal();
                    this.deferring = false;
                }
                this.synchronizing = false;
                this.loading = false;
            }
        });
    }

    selectedTab(tab) {
        console.log('tab', tab);

        let dateValue = this.getInputDateValue(false);

        switch (tab) {
            case 1:
                this.currentSelectedTab = 1;
                this.showReminderBtn = false;
                this.getAssessmentMod1Stats(dateValue);
                break;
            case 2:
                this.currentSelectedTab = 2;
                this.showReminderBtn = true;
                this.getAssessementMod1Pendings(dateValue, true);
                break;
            case 3:
                this.currentSelectedTab = 3;
                this.showReminderBtn = false;
                this.getAssessementMod1Completed(dateValue, true);
                break;
        }
    }

    // getDateTimePikerValue(returnDateText: boolean, separator: string = '-') {
    //     let date = $('.assessmentsModlll .wc-date-container span').text();
    //     let dateArr = date.split('-');

    //     if (returnDateText) {
    //         return dateArr[0] + separator + dateArr[1] + separator + dateArr[2];
    //     } else {
    //         return dateArr[2] + separator + dateArr[0] + separator + dateArr[1] + 'T00:00:00';
    //     }
    // }

    getInputDateValue(returnDateText: boolean, separator: string = '-'): string {
        let date = $('#mod3InputDatePicker').val();

        if (!date) {
            date = this.getTodayDate2();
        }

        let dateArr = date.split('-');

        if (returnDateText) {
/*            console.log("Method true: " + dateArr[1] + separator + dateArr[2] + separator + dateArr[0]);//MM-DD-YYYY*/
            return dateArr[1] + separator + dateArr[2] + separator + dateArr[0];
        } else {
/*            console.log("Method false: " + dateArr[0] + separator + dateArr[1] + separator + dateArr[2] + 'T00:00:00');//YYYY-MM-DD*/
            return dateArr[0] + separator + dateArr[1] + separator + dateArr[2] + 'T00:00:00';
        }
    }

    enableResults() {
        if (this.canEnableResults) {

            this.enabling = true;

            this._AdminService.postEnableResultsModl(this.getInputDateValue(false)).subscribe((data: any) => {
                console.log("postEnableResultsModlll_response", data);
                if (this._Globals.validationToken(data.result.Result)) {
                    //1 Success Message: "Results enabled successfully"
                    //0 Error Message: "We are sorry.  An unexpected error happened when trying to enable the results"
                    switch (data.result.Result) {
                        case 0:
                            this._toastr.error("We are sorry. An unexpected error happened when trying to enable the results.", "ELI");
                            break;
                        case 1:
                            this._toastr.success("Results enabled successfully.", "ELI");
                            break;
                    }

                    console.log(data);

                    this.enabling = false;
                }
            });
        }
    }

    /*AG GRID*/
    sizeToFit(gridApi: any) {
        gridApi.sizeColumnsToFit();
        $('.ag-body-viewport').css('overflow', 'overlay');
    }

    onGridReady(params, grid) {
        if (grid == 1) {
            this.pendingGridApi = params.api;
            this.sizeToFit(this.pendingGridApi);
        } else {
            this.completedGridApi = params.api;
            this.sizeToFit(this.completedGridApi);
        }

        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
        }, 100);

    }

    createPendingHeaders() {
        let columnDefs = new Array();

        let nameHeader = {
            headerName: 'Name',
            field: 'ClientFullName',
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            checkboxSelection: true,
            filterParams: {
                apply: true
            },
            minWidth: 200,
            width: 200,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(nameHeader);

        let emailHeader = {
            headerName: 'Email',
            field: 'ClientEmail',
            filterParams: {
                suppressAndOrCondition: true,
                apply: true
            },
            minWidth: 200,
            width: 200,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return '<div style="overflow:hidden !important;text-overflow:ellipsis;">' + params.value + '</div>';
            }
        };
        columnDefs.push(emailHeader);

        return columnDefs;
    }

    createCompletedHeaders() {
        let columnDefs = new Array();

        let nameHeader = {
            headerName: 'Name',
            field: 'ClientFullName',
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            checkboxSelection: true,
            minWidth: 200,
            width: 200,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(nameHeader);

        let emailHeader = {
            headerName: 'Email',
            field: 'ClientEmail',
            filterParams: {
                suppressAndOrCondition: true,
                apply: true
            },
            minWidth: 200,
            width: 200,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return '<div style="overflow:hidden !important;text-overflow:ellipsis;">' + params.value + '</div>';
            }
        };
        columnDefs.push(emailHeader);

        let completedOnHeader = {
            headerName: 'Completed On',
            field: 'CompletedOn',
            minWidth: 200,
            width: 200,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return '<div style="overflow:hidden !important;text-overflow:ellipsis;">' + params.value + '</div>';
            }
        };
        columnDefs.push(completedOnHeader);

        return columnDefs;
    }

    onRowClicked(e) {
        console.log(e);
    }

    onRowSelected(event) {
        console.log("onRowSelected", event);
    }

    onSelectionChanged(event, grid) {
        console.log("onSelectionChanged ", event);
        this.rowCount = event.api.getSelectedNodes().length;
        this.rowCountData = (grid == 1) ? this.getSelectedRows(this.pendingGridApi) : this.getSelectedRows(this.completedGridApi);
        console.log("selection changed, ", this.rowCount + " rows selected");

        if (this.rowCount >= 1) {
            this.canRemind = true;
            this.canUnassign = true;
            this.canDefer = true;
            this.canAssign = true;
        } else {
            this.canRemind = false;
            this.canUnassign = false;
            this.canDefer = false;
            this.canAssign = false;
        }
    }

    getSelectedRows(gridApi): any {
        console.log("SELECTED", gridApi.getSelectedRows());
        return gridApi.getSelectedRows();
    }

    deselectAllCheckBox(gridApi: any) {
        this.canRemind = false;
        this.canDefer = false;
        this.canUnassign = false;
        gridApi.forEachNode(function (node) {
            node.setSelected(false);
        });
    }

    /*SEND REMINDER*/

    sendReminder() {
        if (this.canRemind) {
            let rows = this.getSelectedRows(this.pendingGridApi);
            let assignmentIds = [];
            rows.forEach((client) => {
                console.log(client);
                assignmentIds.push(client.AssignmentId);
            });
            console.log("assignmentIds", assignmentIds);
            this.sendAssessmentReminder(assignmentIds);
        }
    }

    sendAssessmentReminder(assignmentIds: number[]) {
        $('body').css('cursor', 'wait');
        this.reminding = true;

        this._CoachService.postSendAssessmentReminder(assignmentIds).subscribe((data: any) => {
            console.log('response_PostSendAssessmentReminder', data);
            if (this._Globals.validationToken(data.result.Result)) {
                if (data.result.Result == 1) {
                    this._toastr.success("Invitation email sent successfully", "ELI");
                } else {
                    this._toastr.error("We are sorry. An error occurred while trying to send the invitation email.", "ELI");
                }
            }
            this.reminding = false;
            $('body').css('cursor', 'default');
            this.deselectAllCheckBox(this.pendingGridApi);
        });
    }

    downloadReportAssessmentModl() {

        if (this.canDownload) {
            $('body, #downloadBtn').css('cursor', 'wait');
            this.downloading = true;

            let dateValue = this.getInputDateValue(false);
            let dateText = this.getInputDateValue(true);

            this._AdminService.postDownloadReportAssessmentModl(dateValue, dateText).subscribe((data: any) => {
                console.log('response_postDownloadReportAssessmentModl', data);
                if (this._Globals.validationToken(data.result.Result)) {
                    if (data.result.Result == 1) {
                        this._toastr.success("Generating and zipping the reports is being executed in background. You will receive an email message with the link to download it once this process is finished.", "ELI");
                    } else {
                        this._toastr.error("We are sorry.  An unexpected error happened while trying to generate the background task for zipping the reports.", "ELI");
                    }

                    $('body, #downloadBtn').css('cursor', 'default');
                    this.downloading = false;
                }
            });
        }
    }

    /*UNASSIGN*/
    openConfirmModal() {
        if (!this.canUnassign) {
            this._toastr.warning("Please select the assignments you want to revert.", "ELI");
            return;
        };

        $("#confirmModal").modal({ backdrop: "static" });
        $('#confirmModal').modal('show');
    }

    confirm() {
        this.unassigning = true;
        this.unassignAssessments();
    }

    unassignAssessments() {
        let rows;
        rows = this.getSelectedRows(this.pendingGridApi);

        let assignmentIds = [];
        rows.forEach((client) => {
            console.log(client);
            assignmentIds.push(client.AssignmentId);
        });

        this._CoachService.postUnassignAssessments(assignmentIds).subscribe((data: any) => {
            if (this._Globals.validationToken(data.result.Result)) {
                console.log('response_postUnassignAssessments', data);

                if (data.result.Result == 1) {

                    let rowCount = this.getSelectedRows(this.pendingGridApi);

                    if (rowCount.length > 1) {
                        this._toastr.success("Assessments unassigned successfully.", "ELI");
                    } else {
                        this._toastr.success("Assessment unassigned successfully.", "ELI");
                    }
                    this.canUnassign = false;
                    this.pendingGridApi.forEachNode(function (node) {
                        node.setSelected(false);
                    });

                    this.getAssessementMod1Pendings(this.getInputDateValue(false), true);

                    //this.getCoachAssignedAssessments();
                    $('#confirmModal').modal('hide');
                    this.unassigning = false;

                } else {
                    this._toastr.error("An error happend, please try again.", "ELI");
                    this.unassigning = false;
                }
            }

        });
    }

    /*Add Student*/
    preventSpace(value: string, event: any, id: string) {
        if (value == null || value == "") {
            if (event.keyCode == 32) {
                return false;
            }
        }
        if (value == " ") {
            $('#' + id + '').val('');
        }
    }

    hideAddStudentModal() {
        $('#addStudentModal').modal('hide');
    }

    showAddStudentModal() {
        $('#assessmentsMod3NewEmail').val('');
        $("#addStudentModal").modal({ backdrop: "static" });
        $('#addStudentModal').modal('show');
    }

    addStudent(email: string) {
        console.log(email);

        var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        let validEmail = regex.test(email);
        console.log('Valid', validEmail)
        if (validEmail) {
            this.addNewAssessmentModlStudent(email, this.getInputDateValue(false));

        } else {
            this._toastr.warning('Please enter a valid email address', "ELI");
            $('body').css('cursor', 'default');
        }
    }

    addNewAssessmentModlStudent(email: string, dateValue: string) {

        $('#assessmentsMod3NewEmail').prop("disabled", true);
        this.addingStudent = true;

        let data = {
            "xg2": email,
            "mr1": dateValue
        }

        //{"xg2":"[EMAIL],"mr1":[MOD 3 DATA LONG VALUE]"}
        this._AdminService.postAddNewAssessmentModlStudent(this._CryptoJs.encrypt(JSON.stringify(data), '9s6v9y$B&E)M@McQfTjWnZq4t7w@z%C*')).subscribe((data: any) => {
            console.log('response_postAddNewAssessmentModlllStudent', data);

            if (this._Globals.validationToken(data.result.Result)) {

                //1 Success Message: "Student added successfully"
                //0 Error Message: "We are sorry.  An unexpected error happened while trying to add the student"
                //-1 Student already has a MOD 3 assessment Message:"There is already a MOD 3 assessment assigned to this student"
                //-2 Student not found Message: "The entered email address does not correspond with a valid student at InfusionSoft"
                //-3 Error saving user: Message: "We are sorry.  An unexpected error happened while trying to add the student"

                switch (data.result.Result) {

                    case -7:
                        this._toastr.error('No Post Mod 2 Access tag found this student.', 'ELI');
                        break;

                    case -6:
                        this._toastr.error('The student status is different than Customer-Closed Won.', 'ELI');
                        break

                    case -5:
                        this._toastr.error('The student MOD 1 date does not correspond with the select MOD 1 date.', 'ELI');
                        break;

                    case -4:
                        this._toastr.error('The entered email address does not correspond to a valid student.', 'ELI');
                        break

                    case -3:
                        this._toastr.error('We are sorry. An unexpected error happened while trying to add the student.', 'ELI');
                        break;

                    case -2:
                        this._toastr.error('Email address not found at InfusionSoft.', 'ELI');
                        break;

                    case -1:
                        this._toastr.warning('There is already a MOD 1 assessment assigned to this student.', 'ELI');
                        break;

                    case 0:
                        this._toastr.error('We are sorry. An unexpected error happened while trying to add the student.', 'ELI');
                        break;

                    case 1:
                        this._toastr.success('Student added successfully.', 'ELI');
                        this.getAssessementMod1Pendings(this.getInputDateValue(false), true);
                        this.hideAddStudentModal();
                        break;
                }

                this.addingStudent = false;
                $('#assessmentsMod3NewEmail').prop("disabled", false);
            }
        });
    }

    /*getStudents*/
    getStudents() {
        this.getAssessmentsModlStudents();
    }

    getAssessmentsModlStudents() {

        this.progressRef.start();
        $('body').css('cursor', 'waiting');
        this.getStudentsFlag = true;

        this._AdminService.getAssessmentsModlStudents(this.getInputDateValue(false)).subscribe((data: any) => {
            console.log('response_getAssessmentsModlllStudents', data);
            if (this._Globals.validationToken(data.result.Result)) {
                switch (data.result.Result) {
                    case -1:
                        this._toastr.warning('There are no 1 students for the selected date.', 'ELI');
                        this.progressDone();
                        break;

                    case 0:
                        this._toastr.error('We are sorry. An unexpected error happened while trying to get the students for this date.', 'ELI');
                        this.progressDone();
                        break;

                    case 1:
                        //(Proceed to download file)
                        let _data = JSON.parse(data.result.Data);
                        console.log('_data', _data);
                        let fileName = this.getInputDateValue(false, '_').split('T')[0] + '_MOD3_Students.csv';
                        let base64File = _data;
                        //setTimeout(() => {
                        this.saveFile(fileName, base64File);
                        //},5000);

                        break;
                }
            }
        });
    }

    progressDone() {
        $('body').css('cursor', 'default');
        this.progressRef.complete();
        this.getStudentsFlag = false;
    }

    saveFile(name, data) {
        /*base64 to string*/
        data = atob(data);

        setTimeout(() => {
            this.progressDone();
        }, 1000);

        if (data != null && navigator.msSaveBlob)
            return navigator.msSaveBlob(new Blob([data], { type: "text/csv" }), name);
        var a = $("<a style='display: none;'/>");
        var url = window.URL.createObjectURL(new Blob([data], { type: "text/csv" }));
        a.attr("href", url);
        a.attr("download", name);
        $("body").append(a);
        a[0].click();
        window.URL.revokeObjectURL(url);
        a.remove();
    }


    /*CREATE GROUP*/
    createGroup() {
        this.showCreateModal();
    }

    okCreateGroup() {
        this.creatingGroupFlag = true;
        this.createAssessmentMod3Group();
    }

    showCreateModal() {
        $("#createGroupModal").modal({ backdrop: "static" });
        $('#createGroupModal').modal('show');
    }

    hideCreateModal() {
        $('#createGroupModal').modal('hide');
    }

    createAssessmentMod3Group() {
        //{"hw4":[CURRENT USER ID],"vn8":"[MOD 3 DATE LONG FORMAT]"} 

        let data = {
            'hw4': this._Globals.getUserId(),
            'vn8': this.getInputDateValue(false)
        }
        this._AdminService.postCreateAssessmentMod3Group(this._CryptoJs.encrypt(JSON.stringify(data), '8s6v9y$B&E)M@McQfTtWnZq3t7w@z%C*')).subscribe((data: any) => {
            console.log('response_postCreateAssessmentMod3Group', data);

            if (this._Globals.validationToken(data.result.Result)) {

                switch (data.result.Result) {
                    case -1:
                        this._toastr.warning('No students found for the selected date.', 'ELI');
                        this.creatingGroupFlag = false;
                        break;

                    case 0:
                        this._toastr.error('We are sorry. An unexpected error happened while trying to create the group.', 'ELI');
                        this.creatingGroupFlag = false;
                        break;

                    case 1:
                        this._toastr.success('Mod 1 group is being created in background. Data will be displayed once the process finishes.', 'ELI');
                        this.backgroundProcessInProgressFlag = true;
                        this.startCheckNewGroupStatus();
                        break;
                }

                this.hideCreateModal();
            }
        });
    }

    startCheckNewGroupStatus() {
        this.checkNewGroupProcessActive = true;
        setTimeout(() => { if (this.checkNewGroupProcessActive) this.getAssessmentMod1Stats(this.getInputDateValue(false)); }, 20000);
    }


    /*defer modal*/
    displayDeferModal() {
        if (this.canDefer) {
            this.showDeferModal();
        } else {
            this._toastr.warning('Please select the students to move to another date.', 'ELI');
        }
    }

    showDeferModal() {
        this.todaysDate = new Date();
        $("#deferModal").modal({ backdrop: "static" });
        $('#deferModal').modal('show');
    }

    hideDeferModal() {
        $('#deferModal').modal('hide');
    }

    deferSelectedDate() {

    }

    getCurrentDeferDate() {
        return $('#deferModal .wc-date-container span').text();
    }

    private okDeferStudents() {
        if (this.getInputDateValue(true) == this.getCurrentDeferDate()) {
            this._toastr.warning('Defer date must be different than the current group date.', 'ELI');
            return;
        }
        this.deferStudents();
    }

    deferStudents() {
        this.deferring = true;
        //{"mn2":[SELECTED ASSIGNMENT IDS ARRAY], "op9","04/29/2020"}
        //{"mn2":[SELECTED ASSIGNMENT IDS ARRAY], "op9","[TO GROUP DATE SHORT FORMAT]","sr4":"[FROM GROUP DATE SHORT FORMAT]"} 

        let gridApi;
        if (this.currentSelectedTab == 2) {
            gridApi = this.pendingGridApi;
        } else if (this.currentSelectedTab == 3) {
            gridApi = this.completedGridApi;
        }

        let rows = this.getSelectedRows(gridApi);
        let assignmentIds = [];
        rows.forEach((student) => {
            console.log(student);
            assignmentIds.push(student.AssignmentId);
        });

        let data = {
            'mn2': assignmentIds,
            'op9': this.getCurrentDeferDate(),
            'sr4': this.getInputDateValue(true)
        }

        console.log(data);

        this._AdminService.postDeferStudents(this._CryptoJs.encrypt(JSON.stringify(data), '8s6v9y$B&E)M@McQfTjPnZq4t7w@z%Q*')).subscribe((data: any) => {
            console.log('response_postCreateAssessmentMod3Group', data);

            if (this._Globals.validationToken(data.result.Result)) {

                if (data.result.Result != 1) {
                    this.deferring = false;
                }

                switch (data.result.Result) {
                    case -3:
                        this._toastr.warning('We are sorry. Not all of the selected students were successfully transferred to the new date. Please check the source group pending students list.', 'ELI');
                        break;

                    case -2:
                        this._toastr.warning('We are sorry. The target date corresponds to a group which is being created in background. Please try again later.', 'ELI');
                        break;

                    case -1:
                        this._toastr.warning('We are sorry. An unexpected error happened while trying to created the target group.', 'ELI');
                        break;

                    case 0:
                        this._toastr.error('We are sorry. An unexpected error happened while trying to move the students to the new group.', 'ELI');
                        break;

                    case 1:
                        this._toastr.success('Moving the selected students to the new MOD 1 group finished successfully.', 'ELI');
                        if (this.currentSelectedTab == 2) {
                            this.getAssessementMod1Pendings(this.getInputDateValue(false), true, true);
                        } else if (this.currentSelectedTab == 3) {
                            this.getAssessementMod1Completed(this.getInputDateValue(false), true, true);
                        }

                        this.deselectAllCheckBox(gridApi);
                        break;
                }
            }
        });
    }


    /*Assign Assessments*/
    showAssignAssessmentsModal() {
        this.quantity = 1;
        $("#assignAssessmentsModlllModal").modal({ backdrop: "static" });
        $('#assignAssessmentsModlllModal').modal('show');
    }

    hideAssignAssessmentsModal() {
        $('#assignAssessmentsModlllModal').modal('hide');
    }

    assignAssessmentsModlll() {
        if (this.canAssign) {
            this.showAssignAssessmentsModal();
        } else {
            this._toastr.warning('Please select the students you want to assign the assessments to.', 'ELI');
        }
    }

    allowOnlyNumber(evt: any) {
        var charCode = evt.keyCode;
        console.log(charCode);
        if (parseInt(evt.target.value) <= 0 || evt.target.value == "") {
            $('#' + evt.target.id).val(1);
            if (evt.target.id == 'quantity') { this.quantity = 1; };
            return false;
        } else {
            return true;
        }
    }

    okAssignAssessmentsModlll() {
        this.saveAssessmentAssignmentByAdmin();
    }

    saveAssessmentAssignmentByAdmin() {
        $('body').css('cursor', 'wait');
        this.assigningAssessmentsFlag = true;

        let purchaseArray: AdminAssessmentPurchaseDto[] = [];
        let selected = this.getSelectedRows(this.completedGridApi);

        selected.forEach((x) => {
            purchaseArray.push({
                "LU0": x.StudentId,
                "LU7": 0,
                "LU5": this._Globals.getUserId(),
                "LU4": "",
                "LU3": [
                    {
                        "X2": 1,
                        "X5": parseInt($('#quantity').val()),
                        "X9": 0
                    }, {
                        "X2": 34,
                        "X5": 0,
                        "X9": 0
                    }]
            });
        });

        console.log(purchaseArray);

        this._AdminService.postSaveAssessmentAssignmentByAdmin(purchaseArray).subscribe((data: any) => {
            console.log('response_postSaveAssessmentAssignmentByAdmin', data);

            $('body').css('cursor', 'default');
            this.assigningAssessmentsFlag = false;


            if (this._Globals.validationToken(data.result.Result)) {
                console.log('_data', data);
                if (data.result.Result == 1) {
                    this._toastr.success('Assessments assigned successfully.', 'ELI');
                } else {
                    this._toastr.error('We are sorry. An error happened when trying to complete the purchase process.', 'ELI');
                }
            }

            this.deselectAllCheckBox(this.completedGridApi);
            this.hideAssignAssessmentsModal();
        });
    }

    setActiveTab() {
        setTimeout(() => {
            $('.tab-nav')[0].children[1].classList.remove("active");
            $('.tab-nav')[0].children[2].classList.remove("active");
            $('.tab-nav')[0].children[0].classList.add("active");

            $('.tab-content')[0].children[1].classList.remove("active", "in");
            $('.tab-content')[0].children[2].classList.remove("active", "in");
            $('.tab-content')[0].children[0].classList.add("active", "in");

            this.currentSelectedTab = 1;
        }, 10);

    }

    syncBtn() {
        this.synchronizing = true;
        let data = { "lj7": this.getInputDateValue(false) };
        this._AdminService.postAssessmentsModISync(this._CryptoJs.encrypt(JSON.stringify(data), '8s6v9y$B&E)M@McQfTtWnZq3t7w@z%C*')).subscribe((data: any) => {
            console.log('postAssessmentsModISync', data);

            if (this._Globals.validationToken(data.result.Result)) {

                switch (data.result.Result) {

                    case 0:
                        this._toastr.error('We are sorry. An unexpected error happened while trying to synchronize the Mod 1 group.', 'ELI');
                        this.synchronizing = false;
                        break;

                    case 1:
                        this._toastr.success('Mod 1 group successfully synchronized.', 'ELI');
                        this.selectedTab(this.currentSelectedTab);
                        break;
                }

            }
        });
    }

}
